/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Vpedal_Step_FocusInputs */



/**
* | output |
* | --- |
* | "Keep this application window focused while using the pedal." |
*
* @param {Options_Pedal_Vpedal_Step_FocusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_vpedal_step_focus = /** @type {((inputs?: Options_Pedal_Vpedal_Step_FocusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Vpedal_Step_FocusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Keep this application window focused while using the pedal.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keep this application window focused while using the pedal.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Keep this application window focused while using the pedal.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Keep this application window focused while using the pedal.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Keep this application window focused while using the pedal.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Keep this application window focused while using the pedal.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Keep this application window focused while using the pedal.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Keep this application window focused while using the pedal.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Keep this application window focused while using the pedal.")
	return /** @type {LocalizedString} */ ("Keep this application window focused while using the pedal.")
});